/**
 * @generated SignedSource<<812cbed1ceee92d334ae520db99e3a67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubscriptionPlatform = "android" | "browser" | "ios" | "lemon" | "%future added value";
export type VerifyingMutation$variables = {
  hash: string;
};
export type VerifyingMutation$data = {
  readonly verifyUser: {
    readonly email: string | null;
    readonly emailVerified: boolean;
    readonly id: string;
    readonly subscriptions: ReadonlyArray<{
      readonly cancelled: string | null;
      readonly family: boolean;
      readonly platform: SubscriptionPlatform;
      readonly storeId: string;
      readonly timeToExpire: number;
      readonly transactionId: string;
    }>;
  };
};
export type VerifyingMutation = {
  response: VerifyingMutation$data;
  variables: VerifyingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hash"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "hash",
        "variableName": "hash"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "verifyUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailVerified",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Subscription",
        "kind": "LinkedField",
        "name": "subscriptions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transactionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "storeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeToExpire",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "platform",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "family",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e0db52e456620cd168599ea344beeb15",
    "id": null,
    "metadata": {},
    "name": "VerifyingMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyingMutation(\n  $hash: String!\n) {\n  verifyUser(hash: $hash) {\n    emailVerified\n    id\n    email\n    subscriptions {\n      transactionId\n      storeId\n      timeToExpire\n      platform\n      family\n      cancelled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "507ae40cfb64839aba5a206942e7b62b";

export default node;
